/*
  PDP media gallery + zoom modal: autoplay Shopify-hosted videos (muted, inline, looped)
  while their slide is at least 50% visible. Pauses when out of view, so only
  one video plays at a time. Videos are injected from their <template> only
  when visible, so no video bytes load for slides the shopper never sees.
  Falls back to tap-to-play for reduced motion, Data Saver and 2G.
*/
(function () {
  const connection = navigator.connection || {};
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || connection.saveData || /2g/.test(connection.effectiveType || '')) return;

  const visibleMedia = new Set();

  function getVideo(media) {
    if (!media.getAttribute('loaded')) {
      const video = media.querySelector('template').content.querySelector('video').cloneNode(true);
      // Reuse the already-loaded poster image: no extra 2048px poster download, no blank flash
      const posterImage = media.querySelector(':scope > img');
      if (posterImage && posterImage.currentSrc) video.poster = posterImage.currentSrc;
      video.muted = true;
      video.playsInline = true;
      media.setAttribute('loaded', true);
      media.appendChild(video);
    }
    return media.querySelector('video');
  }

  function update() {
    // Zoom modal open: only its videos may play (gallery stays paused behind it).
    // Modal closed: only gallery videos (the closed modal is still laid out, just transparent).
    const openModal = document.querySelector('product-modal[open]');
    const activeMedia = [...visibleMedia].find((media) =>
      openModal ? openModal.contains(media) : !media.closest('product-modal')
    );
    document.querySelectorAll('deferred-media[data-autoplay-video][loaded] video').forEach((video) => {
      if (video.parentElement !== activeMedia) video.pause();
    });
    if (activeMedia) getVideo(activeMedia).play().catch(() => {});
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio >= 0.5) visibleMedia.add(entry.target);
      else visibleMedia.delete(entry.target);
    });
    update();
  }, { threshold: 0.5 });

  let observedMedia = [];

  // Thumbnail clicks, variant switches and modal open/close call pauseAllMedia(),
  // which pauses every <video>. Re-observing makes the observer report fresh
  // visibility (after any scroll the caller just did, e.g. the modal jumping to the
  // tapped image), and its callback resumes the visible video outside the click's frame.
  const pauseAllMedia = window.pauseAllMedia;
  window.pauseAllMedia = function () {
    pauseAllMedia.apply(this, arguments);
    visibleMedia.clear();
    observedMedia.forEach((media) => {
      observer.unobserve(media);
      observer.observe(media);
    });
  };

  // Start after window load so a first-slide video never competes with the LCP poster image
  function init() {
    observedMedia = document.querySelectorAll('deferred-media[data-autoplay-video]');
    observedMedia.forEach((media) => observer.observe(media));
  }

  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();
